import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { TypeScale, TypeStyle, ColorPalette } from '@theme-ui/style-guide';
import Readme from '@theme-ui/style-guide/README.md';
export const _frontmatter = {
  "title": "@theme-ui/style-guide"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Readme mdxType="Readme" />
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <h3 {...{
      "id": "type-specimens"
    }}>{`Type Specimens`}</h3>
    <TypeStyle fontSize={7} mdxType="TypeStyle">System Font (Body)</TypeStyle>
    <TypeStyle fontFamily="heading" fontWeight="heading" lineHeight="heading" fontSize={7} mdxType="TypeStyle">
  Heading
    </TypeStyle>
    <TypeStyle fontFamily="monospace" fontSize={7} mdxType="TypeStyle">
  Monospace
    </TypeStyle>
    <h3 {...{
      "id": "type-scale"
    }}>{`Type Scale`}</h3>
    <TypeScale fontWeight="heading" mdxType="TypeScale" />
    <h3 {...{
      "id": "color-palette"
    }}>{`Color Palette`}</h3>
    <ColorPalette omit={['modes', 'header']} mdxType="ColorPalette" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      